import { Flex, Input } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormField } from '../../../components/FormField'
import { FormModal } from '../../../components/FormModal'
import { useAppToast } from '../../../helpers'
import { IRoleGroup, IUserGroup, UserGroupService } from '../../../services/UserGroup/UserGroupService'
import { UserGroupPermissionsSelector } from './UserGroupPermissionsSelector'

interface IProps {
  isOpen: boolean
  onClose: () => void
  userGroup: IUserGroup | null
}

interface IForm {
  name: string
  permissions: number[]
}

const defaultForm: IForm = {
  name: '',
  permissions: []
}

export function UserGroupCreateModal({ isOpen, onClose, userGroup }: IProps) {
  const toast = useAppToast()
  const userGroupService = new UserGroupService()
  const [form, setForm] = useState<IForm>(defaultForm)
  const [permissions, setPermissions] = useState<IRoleGroup[]>([])
  const [errors, setErrors] = useState<{ [key: string]: string[] }>({})

  const handleSave = async (event: React.FormEvent) => {
    event.preventDefault()

    if (!formValid()) {
      return
    }

    userGroupService
      .create(form)
      .then(() => {
        toast.success('Grupo de Usuários criado com sucesso')

        onClose()
      })
      .catch((error) => {
        setErrors(error.response.data.errors)
      })
  }

  const formValid = () => {
    return form.name && form.permissions
  }

  const loadPermissionsOptions = async () => {
    const data = await userGroupService.listSystemRoles()
    setPermissions(data)
  }

  useEffect(() => {
    if (!isOpen) {
      return
    }

    loadPermissionsOptions()
    if (userGroup) {
      setForm({
        name: `${userGroup.name} - Cópia`,
        permissions: userGroup.roles.map((role) => role.id)
      })
    } else {
      setForm(defaultForm)
    }
  }, [isOpen, userGroup])

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Criar grupo de usuários"
      onSubmit={handleSave}
      size="editor"
      isConfirmDisabled={!formValid()}
    >
      <Flex direction="column">
        <FormField label="Nome" error={errors.name} isRequired>
          <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </FormField>
        <FormField label="Permissões" mt={4}>
          <UserGroupPermissionsSelector
            permissions={permissions}
            selected={form.permissions}
            onChange={(selected) => setForm({ ...form, permissions: selected })}
          />
        </FormField>
      </Flex>
    </FormModal>
  )
}
